import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { useState } from 'react';
import { format, subMonths, addMonths, } from 'date-fns';
import { cn } from '../../utils';
import { Button } from '../Button';
import { Calendar } from '../Calendar';
import ArrowNarrowLeft from '../Icon/ArrowNarrowLeft';
import ArrowNarrowRight from '../Icon/ArrowNarrowRight';
import { Popover, PopoverContent, PopoverTrigger } from '../Popover';
const DateRangePicker = ({ date, dateFormat, minDate, maxDate, isDisabled, fromDate, toDate, isFromCalendar, onSelect, }) => {
    const [month, setMonth] = React.useState(new Date());
    const [calendarOpen, setCalendarOpen] = useState(false);
    const [dateRange, setDateRange] = React.useState({
        from: fromDate,
        to: toDate,
    });
    const handlePrevMonthClick = () => {
        setMonth(subMonths(month, 1));
    };
    const handleNextMonthClick = () => {
        setMonth(addMonths(month, 1));
    };
    const handleOnSelect = (selected) => {
        setCalendarOpen(false);
        setDateRange(selected);
        onSelect && onSelect(selected);
    };
    return (_jsx(_Fragment, { children: _jsx("div", { className: cn('grid gap-2'), children: _jsxs(Popover, { children: [_jsx(PopoverTrigger, { asChild: true, children: _jsx(Button, { id: "date", variant: 'outline', className: cn('w-full justify-start text-left font-normal', !date && 'text-muted-foreground'), children: dateRange?.from ? (dateRange.to ? (_jsxs(_Fragment, { children: ["From", ' ', _jsx("span", { className: "font-bold", children: format(dateRange.from, 'LLL dd, y') }), ' ', "to", ' ', _jsx("span", { className: "font-bold", children: format(dateRange.to, 'LLL dd, y') })] })) : (format(dateRange.from, 'LLL dd, y'))) : (_jsx("span", { className: "text-muted-foreground", children: "Select a date range" })) }) }), _jsx(PopoverContent, { className: "w-auto p-0", align: "start", children: _jsx(Calendar, { mode: "range", month: month, defaultMonth: dateRange?.from, selected: dateRange, onSelect: handleOnSelect, numberOfMonths: 1, classNames: {
                                day: 'p-0 size-8 text-sm flex-1 flex items-center justify-center has-[button]:hover:!bg-accent rounded-md has-[button]:hover:aria-selected:!bg-[#14532d] has-[button]:hover:text-accent-foreground has-[button]:hover:aria-selected:text-primary-foreground [&>button]:p-1.5',
                            }, disabled: maxDate || minDate
                                ? [
                                    maxDate ? { after: new Date(maxDate) } : undefined,
                                    minDate ? { before: new Date(minDate) } : undefined,
                                ].filter(Boolean)
                                : undefined, components: {
                                PreviousMonthButton: () => (_jsx("div", { onClick: handlePrevMonthClick, className: "cursor-pointer", children: _jsx(ArrowNarrowLeft, { fill: "#111827" }) })),
                                NextMonthButton: () => (_jsx("div", { onClick: handleNextMonthClick, className: "cursor-pointer", children: _jsx(ArrowNarrowRight, { fill: "#111827" }) })),
                            } }) })] }) }) }));
};
export default DateRangePicker;
